import styled from 'styled-components/';
import AppCSS from '../../../utils/styled';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { MENU_MAX_HEIGHT } from '../../../utils/styled/dimensions';

export const Components = {
  Select: styled(Select)<{ hasBorder?: boolean; fontSize: 'default' | 'big' }>`
    width: 100%;
    height: 40px;
    ${({ fontSize }) => (fontSize === 'default' ? AppCSS.fonts.label12Regular : AppCSS.fonts.label14Regular)};
    color: ${AppCSS.colors.blues.veryDark};
    ${AppCSS.radiuses.default};
    background-color: ${AppCSS.colors.blues.light};
    border: ${({ hasBorder }) => (hasBorder ? `1px solid ${AppCSS.colors.blues.veryLight}` : 'none')};
    & .MuiOutlinedInput-notchedOutline {
      border: none;
    }
    & .MuiOutlinedInput-input {
      padding: 2px 0 0 8px;
      padding-right: 0px !important;
    }
  `,
  MenuItem: styled(MenuItem)`
    padding: 8px;
    ${AppCSS.fonts.label14Regular};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  SelectIcon: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    margin-right: 16px;
  `,
};

export const styles = {
  SelectMenu: `
    & .MuiPaper-root {
      ${AppCSS.radiuses.default};
      width: 54px;
      overflow-x: hidden;
      overflow-y: auto;
      max-height: ${MENU_MAX_HEIGHT}px;
      ${AppCSS.boxShadows.menu}
      & .MuiList-root {
        padding: 0;
      }
      & .MuiMenuItem-root {
        ${AppCSS.fonts.label12Regular};
        color: ${AppCSS.colors.blues.veryDark};
        padding: 12px;
        min-width: 145px;
        border-bottom: 1px solid ${AppCSS.colors.greys.light};
        &:hover {
          background-color: ${AppCSS.colors.greys.light};
        }
      }
      & .MuiMenuItem-root:last-child {
        border-bottom: 0;
      }
      & .Mui-selected {
        ${AppCSS.fonts.label12Bold};
      }
    }
  `,
};
